import { ListPageHeaderProps } from '../../../../../ui/components/pure/page-headers/list/list-page-header.component';
import {
  KnownDeliveriesRequiringAttentionState,
  KnownPartyDtoType,
  PartyDto
} from '@groundfloor-platform/mgmt-service-g-sdk';
import { createPath, Paths } from '../../../../../app/router/app.router';
import { UseQueryListDeliveriesRequiringAttentionParams } from '../../deliveries-requiring-attention.queries';
import { Delivery } from '../../../../deliveries/models/delivery.model';

export function makeDeliveriesRequiringAttentionListPageHeaderProps(
  deliveriesCount: number,
  form: UseQueryListDeliveriesRequiringAttentionParams,
  onFormInput: (update: Partial<UseQueryListDeliveriesRequiringAttentionParams>) => void
): ListPageHeaderProps<UseQueryListDeliveriesRequiringAttentionParams> {
  return {
    title: 'Deliveries Requiring Attention',
    subtitle: `${deliveriesCount} ${deliveriesCount === 1 ? 'Delivery' : 'Deliveries'}`,
    controls: {
      form,
      onFormInput,
      inputs: [
        {
          type: 'multi-select',
          label: 'Delivery Requiring Attention State',
          field: 'deliveriesRequiringAttentionState',
          showErrorOnEmptyValue: true,
          options: DeliveriesRequiringAttentionStateOptions,
          isAdvanced: true
        }
      ]
    }
  };
}

export const DeliveriesRequiringAttentionStateOptions: {
  label: string;
  value: string;
}[] = [
  {
    label: 'Overdue with failed notification',
    value: KnownDeliveriesRequiringAttentionState.OverdueWithFailedNotification
  },
  {
    label: 'Overdue without failed notification',
    value: KnownDeliveriesRequiringAttentionState.OverdueWithoutFailedNotification
  },
  {
    label: 'Delivered with failed notification',
    value: KnownDeliveriesRequiringAttentionState.DeliveredWithFailedNotification
  }
];

// Returns the user details page URL for a party, but only for party types that have one
// (customers and occupants). Returns undefined for any other party type or a missing party.
function userPageUrl(party: PartyDto | undefined, projectShortcodeOrID: string): string | undefined {
  if (party && (party.type === KnownPartyDtoType.Customer || party.type === KnownPartyDtoType.Occupant)) {
    return createPath(Paths.customer, { projectID: projectShortcodeOrID, userID: party.id });
  }
  return undefined;
}

export function mapDeliveryDtoToDetailsPageUrl(delivery: Delivery, projectShortcodeOrID: string) {
  // Prefer the recipient's user page; otherwise fall back to the delivering party's user page
  // (e.g. a delivery handed over by an occupant). If neither links to a user, show the deliveries list.
  return (
    userPageUrl(delivery.deliveredTo?.party, projectShortcodeOrID) ??
    userPageUrl(delivery.deliveredBy?.party, projectShortcodeOrID) ??
    createPath(Paths.deliveries, { projectID: projectShortcodeOrID })
  );
}
